import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { RootState } from "../../store/store";
import { LoadingScreen } from "../Loading";
const Video = () => {
  const statusScene = useSelector(
    (state: RootState) => state.scenes.statusScene
  );
  const [loaded, setVideoLoaded] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const prevStatusScene = useRef<string>("");
  useEffect(() => {
    if (statusScene !== prevStatusScene.current && videoRef.current) {
      if (videoRef.current.currentSrc === statusScene) {
        setVideoLoaded(true);
      } else {
        setVideoLoaded(false);
      }
      prevStatusScene.current = statusScene;
    }
  }, [statusScene]);
  const handleLoaded = () => {
    // when new video loaded
    setVideoLoaded(true);
  };

  return (
    <>
      {!loaded && <LoadingScreen />}
      <StyledBackgroundVideo className="w-full h-full inset-0 absolute">
        <video
          ref={videoRef}
          src={statusScene}
          className={`video-in ${loaded ? "" : "hidden"}`}
          autoPlay
          muted
          loop
          onLoadedMetadata={handleLoaded}
        ></video>
      </StyledBackgroundVideo>
    </>
  );
};

export default React.memo(Video);
const StyledBackgroundVideo = styled.div`
  video {
    position: absolute;
    width: 100%;
    height: 100%;
    user-select: none;
    object-fit: cover;
    transition: 1s all;
  }
  .video-in {
    z-index: 1;
    object-fit: cover;
    position: absolute;
    opacity: 1;
    transition: opacity 1s;
  }
`;
